import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=195529de&scoped=true&"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForgotten.vue?vue&type=style&index=0&id=195529de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195529de",
  null
  
)

export default component.exports